import { motion } from "framer-motion";

const chapters = [
  {
    no: "01",
    title: "The Legacy",
    body: "For over three decades, Jagdambay Engineering Works has been a cornerstone of India's industrial scaffolding sector — building trust one project at a time since 1991, with branches in Delhi and Kota.",
  },
  {
    no: "02",
    title: "The Precision",
    body: "Every cuplock component we manufacture is engineered to exacting tolerances. From GA drawings to on-site erection, precision is not a feature — it is our standard.",
  },
  {
    no: "03",
    title: "The Scale",
    body: "Operating across every state in India, we mobilize rapidly for the most demanding environments — with deep specialization in thermal power plant shutdowns and maintenance.",
  },
];

const stats = [
  { value: "30+", label: "Years of Experience" },
  { value: "PAN India", label: "Operations" },
  { value: "6", label: "Core Services" },
];

export const Manifesto = () => {
  return (
    <section
      id="legacy"
      data-testid="legacy-section"
      className="relative bg-background py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-16"
    >
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
        {/* sticky left */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <span className="font-mono text-xs uppercase tracking-widest text-primary">
              [ About the Works ]
            </span>
            <h2 className="font-bebas uppercase leading-[0.85] text-foreground text-7xl md:text-8xl lg:text-9xl mt-6">
              30 Years
              <br />
              <span className="text-primary">of Steel</span>
            </h2>
            <div className="mt-12 grid grid-cols-3 border-t border-border">
              {stats.map((s) => (
                <div key={s.label} className="border-r border-border last:border-r-0 py-6 px-2 md:pr-4 md:pl-0">
                  <div className="font-bebas text-2xl sm:text-3xl md:text-5xl text-foreground leading-none">
                    {s.value}
                  </div>
                  <div className="font-mono text-[9px] md:text-[10px] uppercase tracking-widest text-muted-foreground mt-2">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* scrolling right chapters */}
        <div className="lg:col-span-7 flex flex-col">
          {chapters.map((c, i) => (
            <motion.div
              key={c.no}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: [0.85, 0, 0.15, 1] }}
              className="border-t border-border py-12 md:py-16 first:border-t-0 lg:first:border-t"
            >
              <div className="flex items-baseline gap-6">
                <span className="font-mono text-sm text-primary">{c.no}</span>
                <div>
                  <h3 className="font-bebas uppercase text-4xl md:text-5xl text-foreground">
                    {c.title}
                  </h3>
                  <p className="font-plex text-lg md:text-2xl text-muted-foreground mt-5 leading-relaxed">
                    {c.body}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
